import { PlayersSortByType } from "../../../../components/organisms/PlayersToolbar/PlayersToolbar";
import axios from "../../../privateApi";

type Props = {
  sort: PlayersSortByType;
  playerRoleId: number;
};

export const getEvolvedPlayers = async ({ sort, playerRoleId }: Props) => {
  let url = "/evolved-players";
  if (sort) {
    url += `?sort-${sort}`;
  }
  if (playerRoleId) {
    url += `&player-role-id=${playerRoleId}`;
  }

  const res = await axios.get(url);
  return res.data;
};
